import { PAGE_SIZES, pageCount, pageItems, rangeText } from "../../shared/requestList";

/**
 * The strip under the request list: which rows you're looking at, Previous and Next, the page
 * numbers (replaced by "Page 2 of 22" on a phone) and the rows per page. Hidden when everything
 * fits on the smallest page.
 */
export function Pager({
  page,
  pageSize,
  total,
  onPage,
  onPageSize,
}: {
  page: number;
  pageSize: number;
  total: number;
  onPage: (page: number) => void;
  onPageSize: (size: number) => void;
}) {
  if (total <= PAGE_SIZES[0]) return null;
  const pages = pageCount(total, pageSize);

  return (
    <nav className="pager" aria-label="Pages of requests">
      <div className="pager-info mono" role="status">
        {rangeText(page, pageSize, total)}
      </div>

      <ol className="pager-nums">
        <li>
          <button type="button" className="pager-btn pager-step" disabled={page <= 1} onClick={() => onPage(page - 1)}>
            <span aria-hidden="true">‹ </span>Previous
          </button>
        </li>
        {pageItems(page, pages).map((item, i) =>
          item === "gap" ? (
            <li key={`gap-${i}`} className="pager-num pager-gap" aria-hidden="true">…</li>
          ) : (
            <li key={item} className="pager-num">
              <button
                type="button"
                className="pager-btn"
                aria-label={`Page ${item}`}
                aria-current={item === page ? "page" : undefined}
                onClick={() => onPage(item)}
              >
                {item}
              </button>
            </li>
          ),
        )}
        <li className="pager-of mono" aria-hidden="true">
          Page {page} of {pages}
        </li>
        <li>
          <button type="button" className="pager-btn pager-step" disabled={page >= pages} onClick={() => onPage(page + 1)}>
            Next<span aria-hidden="true"> ›</span>
          </button>
        </li>
      </ol>

      <div className="pager-size" role="group" aria-label="Rows per page">
        <span>Rows</span>
        {PAGE_SIZES.map((n) => (
          <button key={n} type="button" className="pager-btn" aria-pressed={n === pageSize} onClick={() => onPageSize(n)}>
            {n}
          </button>
        ))}
      </div>
    </nav>
  );
}
